import React from 'react'
import HoldDownQuantity from '../../shared/pu-react/components/pallets/HoldDownQuantity';
import NeedTopHat from '../../shared/pu-react/components/pallets/NeedTopHat';
import NeedStiffenerBar from '../../shared/pu-react/components/pallets/NeedStiffenerBar';
import ThroughHoleQuantity from '../../shared/pu-react/components/pallets/ThroughHoleQuantity';

const Hardware = (props) => {
  const {validator, parameters} = props
  return (
    <div className="hardware-section">
      <h5 className="hardware-title">Hardware</h5>
      <div className="row">
        <div className="col-12">
          <HoldDownQuantity {...props} required={true}>
            <small>We recommend a minimum of two per board</small>
            {validator.message(`Hold Down Quantity`, parameters.hold_down_board_quantity, 'required|integer|min:0,num')}
          </HoldDownQuantity>
        </div>
        <div className="col-12">
          <NeedStiffenerBar {...props} required={true}>
            {validator.message(`Need Stiffener Bars`, parameters.pallet_need_stiffener_bar, 'required')}
          </NeedStiffenerBar>
        </div>
      </div>
    </div>
  )
}

export default Hardware;
